export default __webpack_public_path__ + "static/banner_background_valentine-f6c9bf6bb7bb161d8af84d62a1834630.png";